import { objectWithout } from '@art-suite/art-core-ts';
import { ScanGroup, ScanLineItem, ScanOption, ScanPart, ScanRoot, ScanTask } from '../ScanRoot';
import {
  SCAN_PART_OPTIMIZED_FIELDS_TO_REMOVE,
  ScanGroupOptimized,
  ScanLineItemOptimized,
  ScanOptionOptimized,
  ScanPartOptimized,
  ScanRootOptimized,
  ScanTaskOptimized,
} from './ScanRootOptimizedSchemas';

export const isDeoptimizedScanPart = (scanPart: ScanPart): scanPart is ScanPart => !(scanPart as ScanPartOptimized).optimized;

export const isOptimizedScanPart = (scanPart: ScanPart): scanPart is ScanPartOptimized => !isDeoptimizedScanPart(scanPart);

// **************************************************************
// Get De-Optimized Scan (i.e. to serialize and save scan data)
// **************************************************************

export const getDeoptimizedScanPart = (scanPart: ScanPart): ScanPart => {
  if (isDeoptimizedScanPart(scanPart)) return scanPart;
  return objectWithout(scanPart, ...SCAN_PART_OPTIMIZED_FIELDS_TO_REMOVE) as any as ScanPart;
};

export const getDeoptimizedLineItem = (lineItem: ScanLineItemOptimized | ScanLineItem): ScanLineItem => {
  if (isDeoptimizedScanPart(lineItem)) return lineItem;
  return objectWithout(lineItem, ...SCAN_PART_OPTIMIZED_FIELDS_TO_REMOVE) as any as ScanLineItem;
};

export const getDeoptimizedOption = (option: ScanOptionOptimized | ScanOption): ScanOption => {
  if (isDeoptimizedScanPart(option)) return option;
  return {
    ...objectWithout(option, ...SCAN_PART_OPTIMIZED_FIELDS_TO_REMOVE) as any as ScanOption,
    lineItems: (option as any).lineItems?.map(getDeoptimizedLineItem),
  };
};

export const getDeoptimizedTask = (task: ScanTaskOptimized | ScanTask): ScanTask => {
  if (isDeoptimizedScanPart(task)) return task;
  return {
    ...objectWithout(task, ...SCAN_PART_OPTIMIZED_FIELDS_TO_REMOVE) as any as ScanTask,
    options: (task as any).options?.map(getDeoptimizedOption),
  };
};

export const getDeoptimizedGroup = (group: ScanGroupOptimized | ScanGroup): ScanGroup => {
  if (isDeoptimizedScanPart(group)) return group;
  return {
    ...objectWithout(group, ...SCAN_PART_OPTIMIZED_FIELDS_TO_REMOVE) as any as ScanGroup,
    tasks: (group as any).tasks?.map(getDeoptimizedTask),
  };
};

export function getDeoptimizedScan(scan: ScanRootOptimized | ScanRoot): ScanRoot {
  if (isDeoptimizedScanPart(scan)) return scan;
  return {
    ...objectWithout(scan, ...SCAN_PART_OPTIMIZED_FIELDS_TO_REMOVE) as any as ScanRoot,
    groups: (scan as any).groups?.map(getDeoptimizedGroup),
  };
}
